import Vue from 'vue'
import apis from '@/api'
import FormWidgetRule from './form-widget-rule.config'
import associateUtil from '@/util/associate.util'

const queryTable = (params, widget, globalData, getTableConfig, callback) => {
  return new Promise((resolve, reject) => {
    if (widget && widget.associationFormId && globalData.documentId) {
      const request = { ...apis.COMPONENT.QUERY_LIST_COMPONENTS }
      request.params = {
        formId: widget.associationFormId
      }
      Vue.prototype
        .$request(request)
        .asyncThen(
          (resp) => {
            getTableConfig(resp)
            if (globalData.formId) {
              const requestTable = widget.inTable
                ? { ...apis.COMPONENT.QUERY_ASSOCIATED_TABLE_FOR_TABLE }
                : { ...apis.COMPONENT.QUERY_ASSOCIATED_TABLE }
              requestTable.params = {
                originFormId: globalData.formId,
                targetFormId: widget.associationFormId,
                documentId: globalData.documentId,
                page: params.page || 1,
                pageSize: params.pageSize || 10,
                data: globalData.formData,
                filterConditionGroupList: widget.filterConditionGroupList || [],
                assComponentId: widget.uuid,
                associationField: {
                  originUuid: widget.associationField.originUuid,
                  targetUuid: widget.associationField.targetUuid,
                  tableUuid: widget.tableUuid,
                  documentId: globalData.documentId,
                  originValue: globalData.formData && globalData.formData[widget.associationField.originUuid]
                }
              }
              if (JSON.stringify(requestTable.params.data) === '{}') {
                delete requestTable.params.data
              }
              Vue.prototype
                .$request(requestTable)
                .asyncThen(
                  (resp1) => {
                    callback(resp1)
                    resolve(resp1)
                  },
                  (error) => {
                    reject(error)
                  }
                )
                .asyncErrorCatch((error) => {
                  reject(error)
                })
            } else {
              callback({
                code: 'error'
              })
            }
          },
          (error) => {
            reject(error)
          }
        )
        .asyncErrorCatch((error) => {
          reject(error)
        })
    } else {
      getTableConfig({
        code: 'error'
      })
      resolve()
    }
  })
}
const searchTable = (params, widget, globalData, callback) => {
  return new Promise((resolve, reject) => {
    if (
      widget &&
      widget.associationFormId &&
      globalData &&
      globalData.formId &&
      globalData.documentId
    ) {
      const requestTable = widget.isInTable
        ? { ...apis.COMPONENT.QUERY_ASSOCIATED_TABLE_FOR_TABLE }
        : { ...apis.COMPONENT.QUERY_ASSOCIATED_TABLE }
      requestTable.params = {
        originFormId: globalData.formId,
        targetFormId: widget.associationFormId,
        documentId: globalData.documentId,
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        data: globalData.formData,
        filterConditionGroupList: widget.filterConditionGroupList || [],
        assComponentId: widget.uuid,
        associationField: {
          originUuid: widget.associationField.originUuid,
          targetUuid: widget.associationField.targetUuid,
          tableUuid: widget.tableUuid,
          documentId: this.globalData.documentId,
          originValue: this.formData[params.widget.associationField.originUuid]
        }
      }
      Vue.prototype
        .$request(requestTable)
        .asyncThen(
          (resp) => {
            callback(resp)
            resolve(resp)
          },
          (error) => {
            reject(error)
          }
        )
        .asyncErrorCatch((error) => {
          reject(error)
        })
    } else {
      callback({
        code: 'error'
      })
      resolve()
    }
  })
}

const queryTableHeader = (formId) => {
  return new Promise((resolve, reject) => {
    if (formId) {
      const request = {
        ...apis.COMPONENT.QUERY_COMPONENT_LIST,
        params: {
          formId
        }
      }
      Vue.prototype.$request(request).asyncThen((resp) => {
        if (resp.code === 'ok') {
          resolve(resp)
        } else {
          resolve(resp)
        }
      })
    } else {
      resolve({
        code: 'error'
      })
    }
  })
}

const FormValueRadioConfig = {
  // 类型
  componentType: 'FORM_ASSOCIATION',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-associated',
    text: '关联表单',
    optionTitle: true,
    description: '用于关联其他表单的数据'
  },
  componentConfig: {
    ...FormWidgetRule,
    uuid: `32bit uuid`,
    width: 12, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormAssiciated',
      edit: 'FormAssiciated',
      read: 'FormAssiciated'
    },
    inTable: true,
    noBorder: true,
    label: '关联表单',
    displayStyle: 'PAGE_TABLE',
    displayFields: [],
    associationField: {
      originUuid: '',
      targetUuid: ''
    },
    queryTable: queryTable,
    searchTable: searchTable,
    queryTableHeader: queryTableHeader,
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcShowAddModal(...args) {
        const params = args[args.length - 2]
        const callback = args[args.length - 1]
        // console.log(params)
        if (!params.globalData.documentId) {
          Vue.prototype.$message({
            type: 'error',
            message: '请先保存表单'
          })
          return
        }
        const param = {
          formId: params.widget.associationFormId,
          rowDocumentId: null,
          title: '新增记录',
          type: 'EditForm',
          // defaultAssData: {
          //   id: this.globalData.documentId,
          //   name: this.formData[this.widget.associationField.originUuid]
          // },
          callback: (key, proxy) => {
            if (proxy.proxyEvent === 'EDIT_MODAL_SUBMIT' || proxy.proxyEvent === 'EDIT_MODAL_SAVE') {
              // this.initData()
              callback()
            }
            // this.callback(proxy.proxyKey, proxy.proxyType, proxy.proxyEvent, proxy.proxyData)
          }
        }
        // TODO: 需要修改为按类型赋值，还查下拉框
        param.defaultAssData = {}
        param.formData = this.formData
        if (this.widget.componentValueTypes.LOV_INPUT.includes(this.widget.associationField.targetType)) {
          // param.defaultAssData[this.widget.associationField.targetUuid] = {
          //   id: this.globalData.documentId,
          //   name: this.formData[this.widget.associationField.originUuid]
          // }
          let originValue = this.formData[this.widget.associationField.originUuid]
          if (Array.isArray(originValue)) {
            originValue = originValue.map((val) => {
              return val.name || val.username
            })
          } else if (originValue && originValue.id) {
            originValue = originValue.name || originValue.username
          }

          if (this.globalData.rowId) {
            param.defaultAssData[this.widget.associationField.targetUuid] = {
              id: this.globalData.rowId,
              name: originValue
            }
            if (this.widget.associationField.dataSelector && Array.isArray(this.widget.associationField.dataSelector.formAssignments)) {
              this.widget.associationField.dataSelector.formAssignments.forEach(assignment => {
                // param.defaultAssData[assignment.currentFormComponent] = this.formData[assignment.otherFormComponent]
                associateUtil.updateLovAssignments(assignment, this.formData, param.defaultAssData, this.widget)
              })
            }
          }
        } else if (this.widget.componentValueTypes.TEXT_INPUT.includes(this.widget.associationField.targetType)) {
          if (this.widget.associationField.targetType !== 'FORM_DOCUMENT_NUMBER') {
            param.defaultAssData[this.widget.associationField.targetUuid] = this.formData[this.widget.associationField.originUuid]
          }
        } else if (this.widget.componentValueTypes.NUMBER_INPUT.includes(this.widget.associationField.targetType)) {
          if (!isNaN(this.formData[this.widget.associationField.originUuid])) {
            param.defaultAssData[this.widget.associationField.targetUuid] = this.formData[this.widget.associationField.originUuid]
          }
        } else if (this.widget.componentValueTypes.DATE_SELECT.includes(this.widget.associationField.targetType)) {
          // 如果符合日期格式就方式
          if (this.$dayjs(this.formData[this.widget.associationField.originUuid]).isValid()) {
            param.defaultAssData[this.widget.associationField.targetUuid] = this.formData[this.widget.associationField.originUuid]
          }
        } else if (this.widget.componentValueTypes.SELECT_INPUT.includes(this.widget.associationField.targetType)) {
          // param.defaultAssData[this.widget.associationField.targetUuid] = this.formData[this.widget.associationField.originUuid]
          // 需要匹配字符串
        }

        Vue.prototype.$formDataOptEvent.showModalWithFormParam(param)
      },
      lcInitDefaultAssData() {
        let defaultAssData = {}
        if (this.widget.componentValueTypes.LOV_INPUT.includes(this.widget.associationField.targetType)) {
          let originValue = this.formData[this.widget.associationField.originUuid]
          if (Array.isArray(originValue)) {
            originValue = originValue.map((val) => {
              return val.name || val.username
            })
          } else if (originValue && originValue.id) {
            originValue = originValue.name || originValue.username
          }
          if (this.globalData.rowId) {
            defaultAssData[this.widget.associationField.targetUuid] = {
              id: this.globalData.rowId,
              name: originValue
            }
            if (this.widget.associationField.dataSelector && Array.isArray(this.widget.associationField.dataSelector.formAssignments)) {
              this.widget.associationField.dataSelector.formAssignments.forEach(assignment => {
                // param.defaultAssData[assignment.currentFormComponent] = this.formData[assignment.otherFormComponent]
                associateUtil.updateLovAssignments(assignment, this.formData, defaultAssData, this.widget)
              })
            }
          }
          // defaultAssData[this.widget.associationField.targetUuid] = {
          //   id: this.globalData.rowId,
          //   name: this.formData[this.widget.associationField.originUuid]
          // }
          // if (this.widget.associationField.dataSelector && Array.isArray(this.widget.associationField.dataSelector.formAssignments)) {
          //   this.widget.associationField.dataSelector.formAssignments.forEach(assignment => {
          //     // defaultAssData[assignment.currentFormComponent] = this.formData[assignment.otherFormComponent]
          //     associateUtil.updateLovAssignments(assignment, this.formData, defaultAssData)
          //   })
          // }
        } else if (this.widget.componentValueTypes.TEXT_INPUT.includes(this.widget.associationField.targetType)) {
          if (this.widget.associationField.targetType !== 'FORM_DOCUMENT_NUMBER') {
            defaultAssData[this.widget.associationField.targetUuid] = this.formData[this.widget.associationField.originUuid]
          }
        } else if (this.widget.componentValueTypes.NUMBER_INPUT.includes(this.widget.associationField.targetType)) {
          if (!isNaN(this.formData[this.widget.associationField.originUuid])) {
            defaultAssData[this.widget.associationField.targetUuid] = this.formData[this.widget.associationField.originUuid]
          }
        } else if (this.widget.componentValueTypes.DATE_SELECT.includes(this.widget.associationField.targetType)) {
          // 如果符合日期格式就方式
          if (this.$dayjs(this.formData[this.widget.associationField.originUuid]).isValid()) {
            defaultAssData[this.widget.associationField.targetUuid] = this.formData[this.widget.associationField.originUuid]
          }
        } else if (this.widget.componentValueTypes.SELECT_INPUT.includes(this.widget.associationField.targetType)) {
          // param.defaultAssData[this.widget.associationField.targetUuid] = this.formData[this.widget.associationField.originUuid]
          // 需要匹配字符串
          const chooseOptions = this.widget.associationField.chooseOptions || []
          //
          const option = chooseOptions.find(opt => {
            return opt.label === this.formData[this.widget.associationField.originUuid] || opt.id === this.formData[this.widget.associationField.originUuid]
          })
          if (option) {
            defaultAssData[this.widget.associationField.targetUuid] = option.id
          }
        }
        return defaultAssData
      },
      lcShowEditDrawer(...args) {
        const params = args[args.length - 2]
        const callback = args[args.length - 1]
        Vue.prototype.$formDataOptEvent.showModalWithFormParam({
          formId: params.widget.associationFormId,
          rowDocumentId: params.data.data.documentId,
          title: '查看记录',
          type: 'DETAIL_FORM',
          taskId: params.data.data.taskId,
          showFooter: !!params.data.data.status,
          extraProp: {
            showApprovalComments:
              params.data.data.status === 'APPROVING' && !!params.data.data.taskId
          },
          callback: (key, proxy) => {
            callback()
          }
        })
      },
      lcOpenAssociatedTableDrawer(...args) {
        const params = args[args.length - 2]
        const callback = args[args.length - 1]
        // if (!params.globalData.documentId) {
        //   Vue.prototype.$message({
        //     type: 'error',
        //     message: '请先保存表单'
        //   })
        //   return
        // }
        // TODO: 1
        Vue.prototype.$formDataOptEvent.showModalWithFormParam({
          formId: params.globalData.formId,
          rowDocumentId: params.globalData.documentId,
          title: params.widget.label,
          type: 'DETAIL_FORM',
          assoConfig: {
            ...params.widget,
            tableUuid: params.widget.tableUuid,
            isInTable: params.widget.isInTable,
            originValue: this.formData[params.widget.associationField.originUuid],
            documentId: this.globalData.documentId
          },
          callback: (key, proxy) => {
            callback()
          }
        })
      },
      lcOpenAssociatedDetailDrawer(...args) {
        const params = args[args.length - 2]
        const callback = args[args.length - 1]
        // if (!params.globalData.documentId) {
        //   Vue.prototype.$message({
        //     type: 'error',
        //     message: '请先保存表单'
        //   })
        //   return
        // }
        Vue.prototype.$formDataOptEvent.showModalWithFormParam({
          formId: params.globalData.formId,
          rowDocumentId: params.globalData.documentId,
          title: params.widget.label,
          type: 'DETAIL_FORM',
          assoConfig: {
            ...params.widget,
            isInTable: params.widget.isInTable,
            tableUuid: params.widget.tableUuid,
            documentId: this.globalData.documentId,
            originValue: this.formData[params.widget.associationField.originUuid]
          },
          callback: (key, proxy) => {
            callback()
          }
        })
      }
    }
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'SELECT_ASSOCIATED_FORM',
    'ASSOCIATED_COMPONENT',
    'ASSOCIATED_SHOW_TYPE',
    'ASSOCIATED_SELECT_CODES',
    'HIDDEN',
    'ASSOCIATED_ALLOW_ADD'
  ]
}

export default FormValueRadioConfig
